
define('models/user',[],function() {


	var isValidDateFormat = function(value) {

		var segments, month, day, year

		try {
			var segments = value.toString().split("/");
				month 	 = parseInt(segments[0]);
				day 	 = parseInt(segments[1]);
				year 	 = parseInt(segments[2]);
		} catch(e) {}

		return !(!segments ||
				segments.length != 3 ||
				(month < 1 || month > 12) ||
				(day < 1 || day > 31) ||
				(year < 1900 || year > 2100));

	};

	_.extend(Backbone.Validation.validators, {
		spn_url: function(value, attr, customValue, model) {
			if(!$.trim(value))
				return;

				value = value.replace(/ /g, "%20");
			/**
			*
			* Regex for URL
			*
			**/
			if(value && !/^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value)) {
			//;"'"";'' // THis is here becuase the regex breaks the syntax highlighter
				return "Please enter a valid web address.";
			}


			/**
			*
			* duplicate somewhere.
			*
			**/
			var flag = true,
				parseURL = function(url) {
					if(!url.match('^http')) url = 'http://' + url;
					var output = { source: url };

					try {
					    var a = document.createElement('a');
					    a.href = url;
						output.protocol = a.protocol.replace(':','');
				        output.host = a.hostname;
				        output.port = a.port;
				        output.query = a.search;
				        output.path = a.pathname.replace(/^([^\/])/,'/$1');
					} catch(e) {}

					return output;
				}

			function trim(str, chars) {
				return ltrim(rtrim(str, chars), chars);
			}
			function ltrim(str, chars) {
				chars = chars || "\\s";
				return str.replace(new RegExp("^[" + chars + "]+", "g"), "");
			}

			function rtrim(str, chars) {
				chars = chars || "\\s";
				return str.replace(new RegExp("[" + chars + "]+$", "g"), "");
			}

			if(!trim(value)) return true;

			var parsedUrl = parseURL(value);

			$("input").each(function() {
				var this_parsedURL = parseURL($(this).val());
				if(
					this_parsedURL.path == parsedUrl.path &&
					this_parsedURL.query == parsedUrl.query &&
					this_parsedURL.host == parsedUrl.host &&
					!($(this).attr("name") == attr))
					flag = false;
			});

			if(flag == false)
				return "This web address already appears elsewhere. Please make sure all web addresses are unique.";

		},

		required_for_profile: function(value, attr, customValue, model) {
			if(model.get("profileid"))
				return Backbone.Validation.validators.required.apply(this, arguments);
		},
		state_required_for_certain_countries: function(value, attr, customValue, model) {
			var country = model.get("countryid");

			if(country == 225 || country == 38)
				return Backbone.Validation.validators.required.apply(this, arguments);
		},
		require_blogurl_if_title: function(value, attr, customValue, model) {
			console.debug('value: '+ value + ", model: ");
			console.debug(model);
			// If there is a blog url and there is no blog title
			if(model.get("blog_name") && !model.get("blog_url"))
				return "Please enter a link to your blog.";
		},
		require_blogtitle_if_url: function(value, attr, customValue, model) {
			console.debug('value: '+ value + ", model: ");
			console.debug(model);
			// If there is a blog url and there is no blog title

			if(model.get("blog_url") && !model.get("blog_name"))
				return "Please enter a title to your blog.";
		},
		require_podcasturl_if_title: function(value, attr, customValue, model) {

			// If there is a podcast url and there is no blog title


			if(model.get("podcast_name") && !model.get("podcast"))
				return "Please enter a link to your podcast.";
		},
		require_podcasttitle_if_url: function(value, attr, customValue, model) {
			console.debug('require_podcasttitle_if_url');
			console.debug(model);

			// If there is a podcast url and there is no blog title
			if(model.get("podcast") && !model.get("podcast_name"))
				return "Please enter a title to your podcast.";
		},
		valid_twitter_link: function(value, attr, customValue, model) {
			// check if there is a twitter link or twitter handle
			if (value == null || value == ""){return;}
			spaceTest = value.indexOf(" ");
			var twitter_handle_reg = new RegExp('^((?:(?:http(?:s)?:\/\/)?(?:www.)?)?(twitter\.com\/|x\.com\/))?([a-zA-Z0-9_@]{1,15}$)', "ig");
			testthis = twitter_handle_reg.test(value);
			if (testthis === false || spaceTest > -1){
				return "Please enter a valid Twitter page if you have one. Please make certain this web address does not already appear elsewhere. All web addresses must be unique.";
			}
		},
		valid_bluesky_link: function(value, attr, customValue, model) {
			// check if there is a bluesky link or bluesky handle
			if (value == null || value == ""){return;}
			spaceTest = value.indexOf(" ");
			var bluesky_handle_reg = new RegExp('^https?:\\/\\/(bsky\\.app\\/profile\\/[a-zA-Z0-9-]{1,18}\\.bsky\\.social|[a-zA-Z0-9-]{1,18}\\.bsky\\.social)\/?$', 'i');
			//var bluesky_handle_reg = new RegExp('^(?:https?:\/\/bsky\.app\/profile\/([a-zA-Z][a-zA-Z0-9-]{0,17}(?:\.bsky\.social)?)|https?:\/\/([a-zA-Z][a-zA-Z0-9-]{0,17})\.bsky\.social|([a-zA-Z][a-zA-Z0-9-]{0,17}))$', "ig");
			if (bluesky_handle_reg.test(value) === false || spaceTest > -1){
				return "Please enter a valid Bluesky page if you have one. Please make certain this web address does not already appear elsewhere. All web addresses must be unique.";
			}
		},
		/* valid_instagram_link: function(value, attr, customValue, model) {
			// check if there is a valuid instagram link or instagram handle
			if (value == null || value == ""){return;}
			spaceTest = value.indexOf(" ");
			var instagram_handle_reg = new RegExp('^https?:\\/\\/(www\\.)?instagram\\.com\\/[a-zA-Z0-9_\\.]{1,30}\\/?$', 'i');
			//var instagram_handle_reg = new RegExp('^((?:(?:http(?:s)?:\/\/)?(?:www.)?)?(instagram\.com\/))?([a-zA-Z0-9\_\.]{1,30}$)', "ig");
			if (instagram_handle_reg.test(value) === false || spaceTest > -1){
				return "Please enter a valid Instagram page if you have one. Please make certain this web address does not already appear elsewhere. All web addresses must be unique.";
			}

		}, */
		password_confirm: function(b, attr, value, model, json) {
			if(json.password != json.password_confirm)
				return "The passwords you entered do not match - please try again.";
		}
	});

	return Backbone.Model.extend({

		/** @todo @mp replace */

		// @todo @profileEdit import old error messages

		url: 'user',

		validation: {
			password: {
				minLength: 8,
				required: true,
				msg: 'Please type a password with at least 8 characters.'
			},
			password_confirm: {
				password_confirm: true
			},
			firstname: {
				msg: "Please enter your first name.",
				required: true
			},
			birthdate: function(value) {
				if($.trim(value) && !isValidDateFormat(value))
					return "Please enter your birthdate as mm/dd/yyyy.";
			},
			middlename: {

			},
			lastname: {
				msg: "Please enter your last name.",
				required: true
			},
			tagline: {
				required: false,
				maxLength: 70
			},
			suffix: {

			},
			nickname: {

			},

			stateid: {
				/* @email:Error messages not required */
				//msg: "Please select a state or province.",
				//state_required_for_certain_countries: true
			},
			degree_institution: {
				required_for_profile: true
			},
			degree_type: {
				required_for_profile: true
			},
			degree_end: {
				required_for_profile: true
			},
			wikipedia: {
				required: false,
				spn_url: true,
				pattern: /wikipedia\.org/i,
				msg: "Please enter a valid link to a Wikipedia article (specifically about you), making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			position: {

			},
			institution: {
				required: false
			},
			email: {
				msg: "Please enter a valid email address.",
				required: true,
				pattern: /.+@.+/i
			},
			address1: {
				required: false
			},
			city: {
				//	msg: "Please enter your city.",
				required: false
			},
			blog_url: {
				require_blogurl_if_title: true,
				spn_url: true,
				msg: "Please make sure that you have entered a valid link to your blog as well as a title."
			},
			blog_name: {
				require_blogtitle_if_url: true,
				//msg: "Please make sure that you have entered a valid link to your blog as well as a title to your blog."
				msg: "Please make sure that you have entered a valid link to your blog as well as a title."
			},
			podcast: {
				require_podcasturl_if_title: true,
				spn_url: true,
				msg: "Please make sure that you have entered a valid link to your podcast as well as a title to your podcast."
			},
			podcast_name: {
				require_podcasttitle_if_url: true,
				msg: "Please make sure that you have entered a valid link to your podcast as well as a title to your podcast."
			},
			mem_published:{
			},

			mem_content:{},
			biography: {
				minLength: 200,
				maxLength: 5000,
				msg: "Please make sure that your \"About Me\" is between 200 and 5000 characters in length."
			},
			homepage: {
				spn_url: true,
				required:false,
				msg: "Please enter a valid home page if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			website: {
				spn_url: true,
				required: false,
				msg: "Please enter a valid website if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			facebook: {
				spn_url: true,
				required:false,
				pattern: /facebook\.com/i,
				msg: "Please enter a valid Facebook link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			bluesky: {
				valid_bluesky_link: true,
				required:false,
				//pattern: /bsky\.app/i,
				msg: "Please enter a valid Bluesky link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			twitter: {
				spn_url: true,
				required:false,
				pattern: /((twitter\.com\/|x\.com\/)|(@)?)(\w|\d|\_){1,15}/i,
				msg: "Please enter a valid Twitter page if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			twitter_account: {
				valid_twitter_link: true,
				required:false,
				msg: "Please enter a valid Twitter page or handle (@) if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			vimeo: {
			 	spn_url: true,
			 	required:false,
			 	pattern: /vimeo\.com/i,
			 	msg: "Please enter a valid Vimeo link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
		 	},
		 	youtube: {
			 	spn_url: true,
			 	required:false,
			 	pattern: /youtube\.com/i,
			 	msg: "Please enter a valid YouTube link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
		 	},
		 	researchgate: {
			 	spn_url: true,
			 	required:false,
			 	pattern: /researchgate\.net/i,
			 	msg: "Please enter a valid ResearchGate link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
		 	},
		 	orcid: {
				spn_url: true,
				required:false,
				pattern: /orcid\.org/i,
				msg: "Please enter a valid ORCID link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
		 	academia: {
			 	spn_url: true,
			 	required:false,
			 	pattern: /academia\.edu/i,
			 	msg: "Please enter a valid Academia.edu link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
		 	},
		 	linkedin:{
			 	spn_url: true,
			 	required:false,
			 	pattern: /linkedin\.com/i,
			 	msg: "Please enter a valid LinkedIn link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
		 	},
		 	instagram: {
				spn_url: true,
				required:false,
				//valid_instagram_link:true,
				pattern: /instagram\.com/i, 
				msg: "Please enter a valid Instagram link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			vimeo: {
				spn_url: true,
				required:false,
				pattern: /vimeo\.com/i,
				msg: "Please enter a valid Vimeo link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			scholar: {
				spn_url: true,
				required:false,
				pattern:/scholar\.google\.[a-z]{2,3}(\.[a-z]{2})?/i,
				//pattern: /scholar\.google\.com/i,
				msg: "Please enter a valid Google Scholar link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			},
			flickr: {
				spn_url: true,
				required:false,
				pattern: /flickr\.com/i,
				msg: "Please enter a valid Flickr link if you have one, making sure that this web address does not already appear elsewhere (all web addresses must be unique)."
			}
		},

		validationForProfile: {
			biography: {
				minLength: 400,
				msg: "Please make sure that your \"Overview Statement\" is at least 400 characters in length."
			}
		},


		initialize: function() {

			var validationAdjustmentsForProfiles = function() {

				if(this.get("profileid"))
					this.validation = _.extend(this.validation, this.validationForProfile);

			};

			// Lets get user model if a userid or username is given
			if(this.get("userid") || this.get("username")) {
				if(this.errorCallback) {
					this.fetch({
						errorCallback: this.errorCallback,
						success: _.bind(validationAdjustmentsForProfiles, this)
					});
				} else {
					this.fetch({
						success: _.bind(validationAdjustmentsForProfiles, this)
					});
				}
			}
		},

		confirmPassword: function(password, callback, context) {

			this.sync("confirm_password", this, {
				data: {
					password: 	password,
					id: 		this.get("id")
				},
				success: function() { callback.apply((context ? context : this), arguments); }
			});

		},

		profile_url: function() {

			if(this.get("member_profileid"))
				return '//www.'+window.config.rootdomain+'/member/'+this.get("username");
			else
				return '//'+this.get("username")+'.'+window.config.rootdomain+"/";
		},

		photo_url: function() {

			if(this.get("member_profileid"))
				return 'https://www.'+window.config.rootdomain+'/member/'+this.get("username")+"/"+this.get("photo_uploadid")+"/photo.jpg";
				else{
					if (this.get("username").indexOf(".")>0){
						username = this.get("username").replace(/\./g,"-");
						return 'https://'+username+'.'+window.config.rootdomain+'/'+this.get("photo_uploadid")+ '/photo.jpg';
					} else {
						return 'https://'+this.get("username")+'.'+window.config.rootdomain+"/photo.jpg";
					}
				}
		},

		full_name: function(assoc) {

			if(!assoc)
				assoc = this.toJSON();

			if(assoc.lastname && assoc.lastname.length == 1)
				assoc.lastname = assoc.lastname + ".";

			if(assoc.suffix && assoc.suffix.toLowerCase && (assoc.suffix.toLowerCase() == "jr" || assoc.suffix.toLowerCase() == "jr."))
				assoc.suffix = "Jr.";

			if(assoc.suffix && assoc.suffix.toLowerCase && (assoc.suffix.toLowerCase() == "sr" || assoc.suffix.toLowerCase() == "sr."))
				assoc.suffix = "Sr.";

			var full_name;

			if(assoc.prefix)
				full_name = assoc.prefix + " " + assoc.firstname;
			else
				full_name = assoc.firstname;

			if(assoc.middlename) {

				if(assoc.middlename.length == 1) {
					full_name += " " + assoc.middlename.toUpperCase() + ".";
				} else {
					full_name += " " + assoc.middlename;
				}

			}

			full_name += " " + assoc.lastname;

			if(assoc.suffix)
				full_name += ", " + assoc.suffix;

			return full_name;

		},

		hasMemberProfile: function() {

			return !!this.get("member_profileid");

		},

		isProfileHolder: function(){
			return this.get("profileid");
		},

		formattedPhoneList: function() {

			var user = this.toJSON(),
				html = [], j = 0;

			if(!user.work_number && user.main_number && user.profileid)
				user.work_number = user.main_number;

			html[j++] = '<ul class="phonelist">';

			// Phone, if home or mobile is present have it say office
			if(user.work_number) {
				if(user.home_number || user.mobile_number)
					html[j++] = "<li>Work: " + user.work_number + '</li>';
				else
					html[j++] = "<li>Phone: " + user.work_number + '</li>';
			}

			// home number
			if(user.home_number) 	html[j++] = '<li>Home: ' 		+ user.home_number 		+ '</li>';
			if(user.mobile_number) 	html[j++] = '<li>Mobile: ' 		+ user.mobile_number 	+ '</li>';
			if(user.fax_number) 	html[j++] = '<li>Fax: ' 		+ user.fax_number 		+ '</li>';
			if(	user.email &&
				user.showemail) 	html[j++] = '<li><a href="mailto:'+user.email+'">Email: ' + user.email + '</a></li>';

			html[j++] = '</ul>';

			if(html.length > 2)
				return html.join("");
			else
				return "";

		},

		formattedMembership: function() {

			function capitaliseFirstLetter(string){return string.charAt(0).toUpperCase() + string.slice(1);}

			var txt = "";

			var hash = {
				"none": 		"No Membership",
				"coursera": 	"Coursera Member",
				"student": 		"Student Member",
				"sustaining":	"Sustaining Member",
				"contributing":	"Contributing Member",
				"leadership": 	"Leadership Circle",
				"lifetime": "Lifetime Member",
				"basic": 		"Member"
			}

			txt = (hash[this.get("membership")] ? hash[this.get("membership")] : capitaliseFirstLetter(this.get("membership")) + " Member");

			if(this.get("yearPaidThru")) {

				txt += " through "+this.get("yearPaidThru");

				// Extra renew now text
				var year = new Date().getFullYear();
				if(parseInt(this.get("yearPaidThru")) < parseInt(year)) {
					txt += "<br> <a class='renew_button' href='https://payments.socialpsychology.org/payment.php?email="+this.get("email")+"&fromEmail=1&source=profile'>Renew Now in Under 3 Minutes </a>";
				}
			}

			return txt;

		},

		/**






		**/

		fullAddress: function() {


			var user = this.toJSON(),
				html = [], j = 0;

			/**
			*
			* Below is more or less profiles who require city state, etc
			*
			**/


			/**
			*
			*	All Addresses have address1, address2, and address3 will be the first lines.
			*	If they exist
			*
			*
			*/
			if (user.address1) html[j++] = user.address1 + "<br />\n";
			if (user.address2) html[j++] = user.address2 + "<br />\n";
			if (user.address3) html[j++] = user.address3 + "<br />\n";


			/**
			*
			*	Let's format the next line
			*	It will put together the zipcode, city,  and state
			*
			*	This code will put together a line that may look like:
			*/

			// If a zipcode is present and this country has zipcodes in the address lets add it to this line
			if (user.zip && !user.haszipcodeinaddress)
				html[j++] = user.zip + " ";

			/**
			*
			* If there is a just a city and not a state lets put just the city
			* If there is just a state and not a city lets put just the state abbr
			* If there is both lets put city, State abbr
			*/
			var city_state = [];

			if(user.city) {
				city_state.push(user.city);
				if(user.state_abbreviation) city_state.push(", " + user.state);
			} else {
				if(user.state_abbreviation)
					city_state.push(" " + user.state)
			}

			if(city_state.length)
				html[j++] = city_state.join("");

			// If a zipcode is present and this country has zipcodes after city state
			if (user.zip && user.haszipcodeinaddress)
				html[j++] = " " + user.zip + " ";

			if(city_state.length || user.zip)
				html[j++] = "<br />\n";

			/**
			*
			* The last line is simply the countries name
			*
			*/
			if (user.country)
				html[j++] = "<span itemprop=\"location\">" + user.country + "</span><br />\n\n";


			return html.join("");


		},

		memoriamContent: function() {
			var memoriam = this.get("mem_content");
			return memoriam;
		},


		biographyToHTML: function() {

			var bio = this.get("biography");

			function nl2br (str, is_xhtml) {
				var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
			}

			if (!bio.match(/href/)) {
				bio = bio.replace(/\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:(?:[^\s()<>.]+[.]?)+|\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\))+(?:\((?:[^\s()<>]+|(?:\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi, "<a target='_blank' class='dynamic' href='" + "$1" + "'>" + "$1" + "</a>");
			}

			// // lets dynamically link urls
			// var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
			// 	      return text.replace(exp,"<a href='$1'>$1</a>");

			// Lets make certain links contain http inside the href=""
			bio = bio.replace(/href\=\'www\./g, "href=\'http://www.");

			bio = "<p>" + nl2br(bio, 1) + "</p>";

			return bio;
		}

	});


});
